// ---------- 1. カードから reward-XXXX というタグ名を作る ----------
//   例: タイトルが「2,000円OFFクーポン」「2000円クーポン」などでもOK
function getRewardTagFromCard(card) {
  if (!card) return null;

  const titleEl = card.querySelector('h3');
  if (!titleEl) return null;

  const raw = titleEl.textContent || '';
  const normalized = raw.replace(/,/g, '').trim(); // カンマ消す

  const m = normalized.match(/(\d+)\s*円/);
  if (!m) return null;

  const amount = m[1]; // 500, 1000, 2000 ...
  return 'reward-' + amount;
}

// ---------- 2. タグに応じて、すでに交換済みのクーポンを非表示にする ----------
function hideVipRewardsOnce() {
  const grid = document.querySelector('.vip-app-reward-rules');
  if (!grid) return;

  // チラ見え防止
  grid.style.visibility = 'hidden';

  const tags = window.customerTags || [];
  const rewardCards = grid.querySelectorAll(':scope > div');

  rewardCards.forEach((card) => {
    const tag = getRewardTagFromCard(card);
    if (!tag) return;

    const hasCustomerTag = tags.includes(tag);

    // ★ここポイント：タグが付いているものだけ非表示
    if (hasCustomerTag) {
      card.style.display = 'none';
    }
  });

  // 処理が終わったら表示
  grid.style.visibility = 'visible';
}

// ---------- 3. 交換確認ダイアログの「OK」のときだけカードを即時で消す ----------
function patchVipRewardConfirm() {
  const grid = document.querySelector('.vip-app-reward-rules');
  if (!grid) return;

  // 二重適用防止
  if (window.__vipRewardConfirmPatched) return;
  window.__vipRewardConfirmPatched = true;

  const nativeConfirm = window.confirm;
  let lastClickedRewardCard = null;

  // どのカードの「交換する」が押されたかを記録
  grid.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('button');
      if (!button) return;

      const card = button.closest('.h-full.flex.flex-col.justify-between');
      if (!card) return;

      lastClickedRewardCard = card;
    },
    true // capture で先に拾う
  );

  // window.confirm をラップ（テキストや表示タイミングはアプリ側のまま）
  window.confirm = function (message) {
    const result = nativeConfirm(message); // 元の confirm をそのまま呼ぶ

    if (result && lastClickedRewardCard) {
      // 「はい（OK）」を押したときだけカードを消す
      lastClickedRewardCard.style.display = 'none';
    }

    // 次のクリックに備えてクリア
    lastClickedRewardCard = null;

    return result;
  };
}

// ---------- 4. 初期ロード＆戻る時の再適用 ----------
document.addEventListener('DOMContentLoaded', function () {
  hideVipRewardsOnce();
  patchVipRewardConfirm();
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    // bfcache から戻った場合もリロードして Liquid + タグを最新化
    window.location.reload();
  } else {
    hideVipRewardsOnce();
    patchVipRewardConfirm();
  }
});
